import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  confirmTimeKeepingFailed,
  confirmTimeKeepingStart,
  confirmTimeKeepingSuccess,
  resetDataConfirmTimeKeeping,
} from "../redux/confirmTimeKeeping";
import { confirmTimeKeepingAPI } from "core/http/service/timeKeeping";
import { SCREEN } from "helper/roleChecker/Screens";
import { dataConfirmSelector } from "../redux/selector";
import { toast } from "react-toastify";
import { updateControlPage } from "components/common/ListInfinitiveScrolling/redux/controlInfinitiveScrolling";
import {
  getListTimeKeepingManagerStart,
  resetListTimeKeepingManager,
} from "../redux/getListTimeKeepingManager";

function* confirmTimeKeepingWork(action) {
  const { callback } = action.payload;
  const dataConfirm = yield select(dataConfirmSelector);
  const formData = { ...dataConfirm, screenCode: SCREEN.IP_019 };
  try {
    const res = yield call(confirmTimeKeepingAPI, formData);

    yield put({
      type: confirmTimeKeepingSuccess.type,
      payload: res,
    });
    yield put({
      type: updateControlPage.type,
      payload: { id: "timeKeepingManager", limit: 30 },
    });
    yield put({
      type: resetListTimeKeepingManager.type,
    });

    yield put({
      type: getListTimeKeepingManagerStart.type,
    });

    yield put({
      type: resetDataConfirmTimeKeeping.type,
    });
    callback?.();
    toast.success("Gửi xác nhận ngày công thành công");
  } catch (error: any) {
    yield put({
      type: confirmTimeKeepingFailed.type,
    });
    toast.error(error?.response?.data?.message || "Đã có lỗi xảy ra");
  }
}

function* watchConfirmTimeKeeping() {
  yield takeLatest(confirmTimeKeepingStart.type, confirmTimeKeepingWork);
}

export default function* confirmTimeKeepingSaga() {
  yield all([watchConfirmTimeKeeping()]);
}
